import React, { FC, useCallback } from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react";

import { PoliciesPreviewTable } from "../preChats/PoliciesPreviewTable";
import { useChatCategoryStore } from "../../hooks/useChatCategoryStore";

export const PolicyPreview: FC = observer(() => {
  const {
    isLoadingPolicyResearch,
    policyResearchData,
    fetchPolicyResearch,
    policyResearchIsLoadingMore,
    policyResearchHasMoreData,
  } = useChatCategoryStore();

  // Reuse the same browsable policy research data (and its scroll-triggered pagination via
  // fetchPolicyResearch) that PolicyQuestionsTable already fetches, instead of running a
  // second payer-scoped fetch of the same endpoint.
  const policies = policyResearchData.policies || [];

  // Memoized so PoliciesPreviewTable's IntersectionObserver setup (keyed off this identity)
  // doesn't get rebuilt on every mobx re-render of this component.
  const handleLoadMore = useCallback(
    () => fetchPolicyResearch(true),
    [fetchPolicyResearch],
  );
  const handleRefetch = useCallback(
    () => fetchPolicyResearch(),
    [fetchPolicyResearch],
  );

  // Show policies table
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        borderLeft: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <PoliciesPreviewTable
          isLoading={isLoadingPolicyResearch}
          policiesData={policies}
          total={policies.length}
          onLoadMore={handleLoadMore}
          refetchData={handleRefetch}
          isLoadingMore={policyResearchIsLoadingMore}
          hasMoreData={policyResearchHasMoreData}
        />
      </Box>
    </Box>
  );
});
